import { useState, useEffect } from "react";
import { Card, Button, message, Checkbox } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

import { useMsal } from "@azure/msal-react"; //, useAccount
import { FormInput } from "../../Components/FormInputs";
import "./Login.css";
// import { InteractionType } from "@azure/msal-browser";
// import { addData, AzureData } from "../AzureAdLogin/AzureAdActions";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore, useNonPersistAuthStore } from "../../AuthStore/AuthStore";
import {
    GoogleReCaptcha,
    GoogleReCaptchaProvider,
} from "react-google-recaptcha-v3";
import { APIwithoutInterceptor } from "../../Axios/Axios";
import axios from "axios";
import {
    getAuthenticationConfig, userLogin, getValidationMessages,
    generateTokenForAuthentication, getvalidateOtp, getForgotPassword
} from "../../Helpers/APIEndpoints/Endpoints";
import { enc } from "crypto-js";
import { encryptAES } from "../../Helpers/CryptoEncryptDecrypt/CryptoEncrypDecrypt";
import { encrypt } from "../../Helpers/Cryptography/CryptoV2";
import { InteractionStatus } from "@azure/msal-browser";



type LoginPageProps = {
    type: string; // Define the expected type of the 'type' prop
};

type AzureLoginData = {
    accessToken: string;
    idToken: string;
    username: string;
};

const LoginPage: React.FC<LoginPageProps> = ({ type }) => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [isOtpfetched, setIsOtpfetched] = useState(false); // 1 for login, 2 for OTP
    const { instance,inProgress,accounts } = useMsal(); //, accounts
    const navigate = useNavigate();
    const [isforgotpassword, setIsFforgotpassword] = useState(false);
    const location = useLocation();
    type = location.state?.type || type;

    const [azureData, setAzureData] = useState<AzureLoginData | null>(null);
    const { setzustandUsername, redirectUrlPostLogin, setredirectUrlPostLogin, setzustandFinancialYearDetails } = useAuthStore(); //setRememberMe, rememberMe, setAccessToken, setIdToken, setJWTAccessToken, setJWTRefreshToken
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [token, setToken] = useState("");
    const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [formErrors, setFormErrors] = useState<any>({});
    let objError: any = {};
    // This for the security policy json,
    // const [forgetpassword, setForgetpassword] = useState(false);
    // const [rememberme, setRememberme] = useState(false);
    // const [captcha, setCaptcha] = useState(false);
    // const [otpEnabled, setOtpEnabled] = useState(false);
    // const [otpModes, setOtpModes] = useState([]); // <- Store modes as an array
    // const [otpExpiry, setOtpExpiry] = useState(0);
    // const [otpLength, setOtpLength] = useState(6);
    const [disabled, setDisabled] = useState(false);
    const [messagevalidation, setMessageValidation] = useState({});

    const { userId,currentRoleId,permissionRecord } = useAuthStore();

    // one sinlge usestate for the security policy, Raj Potdar, Date : 04-03-2025
    const [security, setSecurity] = useState({
        forgetPassword: false,
        rememberMe: false,
        captcha: false,
        otp: {
            enabled: false,
            modes: [],
            expiryMinutes: 0,
            length: 0
        }
    });
    // const AES_KEY = "1234567890123456"; // 16-byte key (Must match backend)
    // const AES_IV = "1234567890123456"; // 16-byte IV

    // This method is used for getting the IP address from the user sytem.
    const getUserIP = async () => {
        try {
            const response = await axios.get("https://api64.ipify.org?format=json");
            const data = await response.data;
            return data.ip; // Extract the IP address
        } catch (error) {
            console.error("Error fetching IP:", error);
            return null;
        }
    };

    // This is for getting the user Context
    const getUserContext = () => {
        return {
            userAgent: navigator.userAgent,
            language: navigator.language,
            platform: navigator.platform,
            screenResolution: `${window.screen.width}x${window.screen.height}`,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    };

    const fetchAuthenticationConfig = async () => {
        try {
            const response = await APIwithoutInterceptor.post(
                getAuthenticationConfig
            );

            const data = response.data;
            return JSON.parse(data.data); // Ensure correct parsing
        } catch (error) {
            console.error("Error fetching authentication config:", error);
            throw error; // Re-throw for proper error handling
        }
    };

    const handleError = (messageText: string) => {
        setError(messageText);
        //message.error(messageText);
    };

    // This is for the password validation
    const validateInputData = async (
        password: string,
        username: string | any[]
    ) => {
        try {
            // Parse the AuthType JSON string fetch the API
            const parsedData = await fetchAuthenticationConfig();

            // Extract the passwordPolicy
            // const passwordPolicy = parsedData.security.passwordPolicy;
            const useremailpolicy = parsedData.userNameType;

            if (username == null || username == "" || username == undefined) {
                // setUsernameerror('Username is required.');
                objError["username_isempty"] = "Username is required";
            }

            if (!password && useremailpolicy === "Email") {
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!emailRegex.test(username as string)) {
                    objError["username_isempty"] = "Please enter a valid user email.";
                }
            }

            setFormErrors(objError);

            // Return false if there are errors, otherwise true
            return Object.keys(objError).length === 0;
        } catch (error) {
            return "Error validating password. Please try again.";
        }
    };

    const validateLogin = async () => {
        setDisabled(true);
        try {
            const ip = await getUserIP();
            const userContext = getUserContext();

            let isValidData = await validateInputData(password, username);
            if (password == null || password == "" || password == undefined) {
                objError["password_isempty"] = "Password is required";
                setFormErrors(objError);
                isValidData = false;
            }
            if (isValidData) {
                const encryptedpassword = encrypt(password);
                console.log("Encrypted Password:", encryptedpassword);
                const response = await APIwithoutInterceptor.post(userLogin, {
                    loginId: username,
                    password: encryptedpassword,
                    ipAddress: ip,
                    ...userContext,
                });
             
                const data = await response.data;
                console.log('data after resonse.data',data)
                if (data.message == "OK") {
                    //response.ok &&
                    if (data.data.isValidUser == true) {
                        if (security.otp.enabled) {
                            setIsOtpfetched(true); // Move to OTP step
                        } else {
                            message.success("Login successful!");
                            if (redirectUrlPostLogin) {
                                window.location.href = redirectUrlPostLogin;
                                setredirectUrlPostLogin('');
                                // let userRoleArr = data.data?.userRoleList.map((role:any) => role.Id);
                                // console.log('userRole arr',userRoleArr)
                                // let navigateTo = [1, 2, 3].some(role => userRoleArr.includes(role)) ? "/VerificationPOI" : "/EmployeeTabs"
                                // console.log('navigateTo',navigateTo)
                                // navigate(navigateTo, { state: { type: type } });
                            }
                            else {
                                console.log('insdie home vala navigation')
                                navigate("/home");
                            }

                        }

                        message.success("Login validated. Please enter the OTP.");
                    } else {

                        setIsOtpfetched(false); // Stay on login step
                    }
                } else {
                    setError(data.message);
                    message.error(data.message);
                    setIsOtpfetched(false);
                }
            }
        } catch (error) {
            handleError("An error occurred while validating login. Please try again.");
            setDisabled(false);
        }
        setTimeout(() => {
            setDisabled(false);
        }, 2000);
    };

    const validateOtp = async () => {
        setDisabled(true);
        if (otp.length < security.otp.length) {
            setError("OTP must be at least 6 characters long");
            return;
        }

        try {
            const ip = await getUserIP();
            const userContext = getUserContext();
            // TODO : Neeed to replace the api url.
            const response = await APIwithoutInterceptor.post(getvalidateOtp, {
                loginId: username,
                otp: otp,
                ipAddress: ip,
                ...userContext,
                isForgotPassword: isforgotpassword,
            });

            const data = await response.data;

            if (data.message == "OK") {
                //response.ok &&
                setError("");
                if (isforgotpassword === true) {
                    // setzustandUsername(username);
                    navigate("/forgot-password", {
                        state: { type: type, username: username },
                    });
                } else {
                    //setzustandUsername(username);
                    setzustandUsername(username, data.data?.Id,data.data?.defaultRoleId,
                        data.data?.defaultPermissionsList,data.data?.userRoleList,data.data?.financialYearList);
                    setzustandFinancialYearDetails(data.data?.currentFinancialYearId);

                    useNonPersistAuthStore.getState().setJWTAccessTokenDev(data.data.accessToken);
                    message.success("Login successful!");
                    if (redirectUrlPostLogin) {
                        console.log('redirecUrlPost',redirectUrlPostLogin);
                        window.location.href = redirectUrlPostLogin;
                        setredirectUrlPostLogin('');
                        // let userRoleArr = data.data?.userRoleList.map((role:any) => role.Id);
                        //         console.log('userRole arr',userRoleArr)
                        //         let navigateTo = [1, 2, 3].some(role => userRoleArr.includes(role)) ? "/VerificationPOI" : "/EmployeeTabs"
                        //         console.log('navigateTo',navigateTo)
                        //         navigate(navigateTo, { state: { type: type } });
                    }
                    else {
                        let navigateTo = "/home" //data.data?.defaultRoleId == 4 ? "/EmployeeTabs" : "/VerificationPOI"
                        navigate(navigateTo);
                    }


                }
            } else {
                handleError(data.message || "Invalid OTP");
            }
        } catch (error) {
            handleError("An error occurred while validating OTP. Please try again.");
            console.error("Error:", error);
        }
        setTimeout(() => {
            setDisabled(false);
        }, 2000);
    };

    // useEffect(() => {
    //     const loginWithAzure = async () => {
       
    //         try {
    //             console.log("loginWithAzure");
    //             console.log("type : ", type);
    //             // Check if the login type is Azure
    //             if (type === "Entra") {
    //                 // Parse AuthType and extract values
    //                 const parsedData = await fetchAuthenticationConfig(); // Parse the JSON string
    //                 // const azureAd = parsedAuthType.authentication.azureAd;
              
    //                 const scopes = parsedData.scopes || ["User.Read"];

    //                 console.log("await instance.loginPopup");

    //                 const response = await instance.loginPopup({
    //                     scopes: scopes, // Define your required scopes
    //                 });

    //                 if (response) {
                        
    //                     console.log("response : ", response);

    //                     // Extract necessary data
    //                     const { accessToken, idToken, account } = response;

    //                     console.log("account.username : ", account.username);

    //                     // API CALL for getting the jwt token
    //                     const jwtresponse = await APIwithoutInterceptor.post(generateTokenForAuthentication, {
    //                         loginId: account.username,
    //                     });

    //                     console.log("accessToken : ", accessToken);

    //                     if(jwtresponse?.data?.status === 0)
    //                         {
    //                             const jwtdata = await jwtresponse.data;
    //                             useNonPersistAuthStore.getState().setJWTAccessTokenDev(jwtdata?.data?.jwttoken);
                         
    //                             // Store the data in the state
    //                             setAzureData({
    //                                 accessToken,
    //                                 idToken,
    //                                 username: account.username,
    //                             });
    //                             setzustandUsername(account.username, jwtdata.data?.Id,
    //                                 jwtdata.data?.defaultRoleId,jwtdata.data?.defaultPermissionsList,
    //                                 jwtdata.data?.userRoleList,jwtdata.data?.financialYearList);
    //                             setzustandFinancialYearDetails(jwtdata.data?.currentFinancialYearId);
                                
    //                             //message.success("Azure AD login successful!");

    //                             //message.success("Logged in successfully!");

    //                             console.log('jwtdata.data?.userRoleList',jwtdata.data?.userRoleList)
    //                             let userRoleArr = jwtdata.data?.userRoleList.map((role:any) => role.Id);
    //                             console.log('userRole arr',userRoleArr)
    //                             let navigateTo = [1, 2, 3].some(role => userRoleArr.includes(role)) ? "/VerificationPOI" : "/EmployeeTabs"
    //                             console.log('navigateTo',navigateTo)
    //                             navigate(navigateTo, { state: { type: type } });
    //                         }
    //                         else
    //                         {
    //                             message.error("Error during Azure AD login");
    //                             setTimeout(() => {
    //                                 navigate("/");
    //                             }, 5000);
    //                         }

    //                     // const jwtdata = await jwtresponse.data;
    //                     // useNonPersistAuthStore.getState().setJWTAccessTokenDev(accessToken);

    //                     // console.log("setAzureData");
    //                     // // Store the data in the state
    //                     // setAzureData({
    //                     //     accessToken,
    //                     //     idToken,
    //                     //     username: account.username,
    //                     // });
    //                     // console.log("setzustandUsername");
    //                     // setzustandUsername(account.username);

    //                     // message.success("Azure AD login successful!");
    //                     // navigate("/home", { state: { type: type } });
    //                 }
    //                 else {
    //                     console.error("Error during Azure AD login:", error);
    //                 }
    //             }
    //         } catch (error) {
    //             console.error("Error during Azure AD login:", error);
    //             handleError("Azure AD login failed. Please try again.");
    //         }
    //     };

    //     // Trigger Azure login on component mount
    //     // alert("aaddeasddd");
    //     loginWithAzure();
    // }, [type, instance]);



    useEffect(() => {
    const loginWithAzureRedirect = async () => {
        try {
            if (type !== "Entra") return;

            if (inProgress !== InteractionStatus.None) return;

            const accounts = instance.getAllAccounts();
            const redirectFlag = sessionStorage.getItem("azureRedirectInProgress");

            console.log("MSAL state:", {
                inProgress,
                accountsLength: accounts.length,
                redirectFlag
            });


            if (accounts.length === 0 && !redirectFlag) {
                sessionStorage.setItem("azureRedirectInProgress", "true");

                const parsedData = await fetchAuthenticationConfig();
                const scopes = parsedData.scopes || ["User.Read"];

                await instance.loginRedirect({ scopes });
                return;
            }

            if (accounts.length === 0) {
                console.log("Waiting for MSAL to hydrate account...");
                return;
            }

            sessionStorage.removeItem("azureRedirectInProgress");

            const account = accounts[0];
            instance.setActiveAccount(account);

            const tokenResponse = await instance.acquireTokenSilent({
                account,
                scopes: ["User.Read"],
            });

            // 🔹 Backend JWT
            const jwtresponse = await APIwithoutInterceptor.post(
                generateTokenForAuthentication,
                { loginId: account.username }
            );

            if (jwtresponse?.data?.status === 0) {
                const jwtdata = jwtresponse.data;

                useNonPersistAuthStore
                    .getState()
                    .setJWTAccessTokenDev(jwtdata?.data?.jwttoken);

                setAzureData({
                    accessToken: tokenResponse.accessToken,
                    idToken: tokenResponse.idToken,
                    username: account.username,
                });

                setzustandUsername(
                    account.username,
                    jwtdata.data?.Id,
                    jwtdata.data?.defaultRoleId,
                    jwtdata.data?.defaultPermissionsList,
                    jwtdata.data?.userRoleList,
                    jwtdata.data?.financialYearList
                );

                setzustandFinancialYearDetails(
                    jwtdata.data?.currentFinancialYearId
                );

                const userRoleArr = jwtdata.data?.userRoleList.map(
                    (role: any) => role.Id
                );

                const navigateTo = [1, 2, 3].some(role =>
                    userRoleArr.includes(role)
                )
                    ? "/VerificationPOI"
                    : "/EmployeeTabs";

                navigate(navigateTo, { state: { type } });
            } else {
                sessionStorage.removeItem("azureRedirectInProgress");
                message.error("Azure login failed");
                navigate("/");
            }
        } catch (error) {
            sessionStorage.removeItem("azureRedirectInProgress");
            console.error("Azure redirect login error:", error);
            handleError("Azure AD login failed.");
        }
    };

    loginWithAzureRedirect();
}, [type, inProgress, instance]);

    // New useEffect for the Custom Login
    useEffect(() => {
        const loginWithCustom = async () => {
            try {
                // Check if the login type is Custom
                if (type === "Custom") {
                    // Parse AuthType and extract values
                    const parsedData = await fetchAuthenticationConfig(); // Parse the JSON string
                    setSecurity(prevState => ({
                        ...prevState,
                        forgetPassword: parsedData.security.forgetPassword,
                        rememberMe: parsedData.security.rememberMe,
                        captcha: parsedData.security.captcha,
                        otp: {
                            ...prevState.otp,
                            enabled: parsedData.security.otp?.enabled || false,
                            modes: parsedData.security.otp?.modes || [],
                            expiryMinutes: parsedData.security.otp?.expiryMinutes || 0,
                            length: parsedData.security.otp?.length || 0
                        }
                    }));
                    console.log("captca:", token);

                    // this API call is for the message valdiation
                    const message = await APIwithoutInterceptor.post(
                        getValidationMessages
                    );

                    var messageresponse = await message.data;
                    console.log("messageresponse:", messageresponse);

                    setMessageValidation(messageresponse);
                }
            } catch (error) {
                console.error("Error during Custom login:", error);
                handleError("Custom login failed. Please try again.");
            }
        };

        // Trigger Custom login on component mount
        loginWithCustom();
    }, [type]);

    // Forgot Passowrd
    const updateforgotpasswordstate = () => {
        setPassword("");
        setError("");
        setIsFforgotpassword(true);
    };
    const updateloginstate = () => {
        navigate("/");
    };

    const validateforgotpassword = async () => {
        setDisabled(true);
        try {
            let isValidData = await validateInputData(password, username);
            if (isValidData) {
                // TODO : Neeed to replace the api url.
                const response = await APIwithoutInterceptor.post(
                    getForgotPassword,
                    {
                        LoginId: username || "",
                    }
                );

                const data = await response.data;
                console.log("Response Status:", response.status);
                console.log("Response Data:", data);

                if (data.message == "OK") {
                    //response.ok &&
                    setError("");
                    message.success("OTP sent to your email ID.");
                    setIsOtpfetched(true); // Move to OTP step
                } else {
                    setError(data.message);
                    message.error(data.message);
                    setError("");
                    setError("");
                }
            }
        } catch (error) { }
        setTimeout(() => {
            setDisabled(false);
        }, 2000);
    };

    const setTokenFunc = (getToken: string) => {
        setToken(getToken);
    };

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => setError(""), 3000);
            return () => clearTimeout(timer); // Cleanup to prevent memory leaks
        }
    }, [error]);

    return (
        
            <>
            {(type === "Custom" || type === "Dual Login") ? (
                <div className="login-container">
                <Card className="login-card">
                    <h1 className="login-title">Login Page</h1>
                    <p className="login-subtitle">Login to continue</p>

                    
                        <div>
                            {isOtpfetched === false && (
                                <>
                                    <div className="form-group text-center mt-3">
                                        <FormInput
                                            name="username"
                                            label="User Name"
                                            placeholder="Username"
                                            inputType="text"
                                            value={username}
                                            onChange={(e: any) => setUsername(e.target.value)}
                                            prefix={<UserOutlined />}
                                            widthSize="large"
                                        ></FormInput>
                                        <p style={{ color: "red" }}>
                                            {formErrors["username_isempty"]}
                                        </p>
                                    </div>
                                    {isforgotpassword === false && (
                                        <div className="form-group text-center mt-3">
                                            <FormInput
                                                name="password"
                                                label="Password"
                                                placeholder="Password"
                                                inputType="password"
                                                value={password}
                                                onChange={(e: any) => setPassword(e.target.value)}
                                                prefix={<LockOutlined />}
                                                widthSize="large"
                                            ></FormInput>
                                            {/* password_isempty */}
                                            <p style={{ color: "red" }}>
                                                {formErrors["password_isempty"]}
                                            </p>
                                        </div>
                                    )}
                                    {/* Checkbox added here */}
                                    <div className="remember-forgot-container">
                                        {/* Checkbox */}
                                        {isforgotpassword === false && (
                                            <>
                                                {/* Remember Me Checkbox */}
                                                {security.rememberMe && (
                                                    <Checkbox
                                                        checked={isChecked}
                                                        onChange={(e:any) => setIsChecked(e.target.checked)}
                                                    >
                                                        Remember Me
                                                    </Checkbox>
                                                )}
                                                {/* Forgot Password link */}
                                                {security.forgetPassword && (
                                                    <a
                                                        onClick={updateforgotpasswordstate}
                                                        className="forgot-password-link"
                                                    >
                                                        Forgot Password?
                                                    </a>
                                                )}
                                            </>
                                        )}
                                        {isforgotpassword === true && (
                                            <>
                                                <a
                                                    onClick={updateloginstate}
                                                    className="forgot-password-link"
                                                >
                                                    Back to Login.
                                                </a>
                                            </>
                                        )}
                                    </div>
                                    {error && (
                                        <div className="login-error">
                                            <span style={{ color: "red" }}>{error}</span>
                                        </div>
                                    )}
                                    {/* Need to add the project in google for the recapta. */}
                                    {security.captcha && (
                                        <div className="text-center mt-3">
                                            <GoogleReCaptchaProvider reCaptchaKey="6LeNYM0qAAAAALUSeHz48n-OvsvHB29X_CosR2T5">
                                                <GoogleReCaptcha
                                                    onVerify={setTokenFunc}
                                                    refreshReCaptcha={refreshReCaptcha}
                                                />
                                            </GoogleReCaptchaProvider>
                                        </div>
                                    )}

                                    <Button
                                        type="primary"
                                        disabled={disabled}
                                        className="login-button"
                                        onClick={
                                            isforgotpassword === false
                                                ? validateLogin
                                                : validateforgotpassword
                                        }
                                    >
                                        {isforgotpassword === false ? "Login" : "Submit"}
                                    </Button>
                                </>
                            )}
                            {isOtpfetched === true && (
                                <div className="form-group text-center mt-3">
                                    <FormInput
                                        name="otp"
                                        label="OTP"
                                        placeholder="enter the otp"
                                        inputType="password"
                                        value={otp}
                                        onChange={(e: any) => setOtp(e.target.value)}
                                        widthSize="large"
                                    ></FormInput>

                                    {error && (
                                        <div className="login-error">
                                            <span style={{ color: "red" }}>{error}</span>
                                        </div>
                                    )}
                                    <Button
                                        type="primary"
                                        disabled={disabled}
                                        className="login-button"
                                        onClick={validateOtp}
                                    >
                                        Verify OTP
                                    </Button>
                                </div>
                            )}
                        </div>
                
                    {/* TOBEDONE : To be implemented later. */}
                    {/* {(type === 'SSO' || type === 'Dual Login') && (
                    <>
                        <div className="text-center mt-4">
                            <Link href="/sso-login" style={{ fontSize: '16px' }}>
                                Login with SSO
                            </Link>
                        </div>
                    </>
                )} */}
                </Card>
                </div>
             ) : (
                <div>Please wait while we are Redirecting...</div>
            )}
             </>
    );
};

export default LoginPage;